import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { updateSettings, fetchSettings } from 'actions'
import { currentUserIdSelector, settingsSelector } from 'selectors'
import { header5 } from 'styles/texts'
import { Form, Field, Checkbox, Label, FormContainer } from 'components/form'

import ButtonComponent from 'components/Button'

const FormWrapper = styled(FormContainer)`
  margin: 60px auto;
`

const Heading = styled.div`
  ${header5};
  font-weight: 700;
`

const Button = styled(ButtonComponent)`
  margin-top: 20px;
`

class Settings extends React.Component {
  state = {
    messageEmail: this.props.messageEmail || false,
    hasChanged: false,
  }

  componentDidMount() {
    this.props.fetchSettings(this.props.userId)
  }

  componentDidUpdate(prevProps) {
    if (
      !this.state.hasChanged &&
      this.props.messageEmail !== prevProps.messageEmail
    ) {
      this.setState({ messageEmail: this.props.messageEmail })
    }
  }

  updateSettings = e => {
    e.preventDefault()
    this.props.updateSettings({ messageEmail: this.state.messageEmail })
    this.setState({ hasChanged: false })
  }

  render() {
    return (
      <FormWrapper title="Innstillinger">
        <Form onSubmit={this.updateSettings}>
          <Heading>Notifikasjoner</Heading>
          <Field>
            <Checkbox
              id="messageEmail"
              checked={this.state.messageEmail}
              onChange={e =>
                this.setState({
                  messageEmail: e.target.checked,
                  hasChanged: true,
                })
              }
            />
            <Label htmlFor="messageEmail">
              Send e-post når du får en melding
            </Label>
          </Field>
          {this.state.hasChanged && <Button type="submit">Lagre</Button>}
        </Form>
      </FormWrapper>
    )
  }
}

const mapStateToProps = state => ({
  userId: currentUserIdSelector(state),
  ...(settingsSelector(state) || {}),
})

const mapDispatchToProps = { fetchSettings, updateSettings }

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/pages/Settings.js